import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConstantsService } from './api-constants.service';
import {
  Roles,
  RolesCreationParams,
  RolesListParams
} from '~core/models/roles.models';
import { Pagination, RequestParams } from '~core/models/core.models';

@Injectable()
export class RolesService {
  private _http = inject(HttpClient);
  private _apiConstantsService = inject(ApiConstantsService);

  list(
    params?: RequestParams & {
      [key: string]: any;
    }
  ): Observable<Pagination<Roles>> {
    return this._http.get<Pagination<Roles>>(
      this._apiConstantsService.rolesUrl,
      {
        params: {
          ...params,
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }

  read(roleId: string, params?: RolesListParams): Observable<Roles> {
    return this._http.get<Roles>(
      `${this._apiConstantsService.rolesUrl}/${roleId}`,
      { params }
    );
  }

  create(payload: RolesCreationParams): Observable<Roles> {
    return this._http.post<Roles>(this._apiConstantsService.rolesUrl, payload);
  }

  update(
    roleId: string,
    payload: Partial<RolesCreationParams>
  ): Observable<Roles> {
    return this._http.patch<Roles>(
      `${this._apiConstantsService.rolesUrl}/${roleId}`,
      payload
    );
  }

  delete(roleId: string): Observable<unknown> {
    return this._http.delete(`${this._apiConstantsService.rolesUrl}/${roleId}`);
  }
}
